import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import Sidebar from './Sidebar';
import Navbar from './Navbar';

interface LayoutProps {
    children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
    // Sidebar should be visible by default on large screens, hidden on mobile
    const [sidebarOpen, setSidebarOpen] = useState(() => window.innerWidth >= 1024);

    // Keep sidebar state in sync with viewport: open on desktop, closed on mobile
    useEffect(() => {
        const onResize = () => {
            if (window.innerWidth >= 1024) {
                setSidebarOpen(true);
            }
        };
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    return (
        <div className="flex h-screen bg-gray-50">
            {/* Sidebar */}
            <Sidebar isOpen={sidebarOpen} onToggle={toggleSidebar} />

            {/* Main content area */}
            <div className="flex-1 flex flex-col overflow-hidden lg:ml-0">
                {/* Navbar */}
                <Navbar onToggleSidebar={toggleSidebar} />

                {/* Page content */}
                <main className="flex-1 overflow-auto">
                    {/* Avoid transforms on ancestors to prevent mispositioned dropdowns/popovers */}
                    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.3 }} className="p-6">
                        {children}
                    </motion.div>
                </main>
            </div>
        </div>
    );
};

export default Layout;
